import React, { Component } from "react";
import goldlog from "@ali/goldlog";
import {
  Input,
  CascaderSelect,
  Feedback
} from '@alife/next';
import { cplRepo, getLogin, queryMobilePhone, sendSmsCode } from "../../../../service";
import CountdownButton from "./countdownButton";
import "./index.scss";

const staticData = [
  {
    value: 7 * 24 * 60 * 60 * 1000,
    label: '临时采购（7天）'
  },
  {
    value: 14 * 24 * 60 * 60 * 1000,
    label: '正常采购（14天）'
  },
  {
    value: 30 * 24 * 60 * 60 * 1000,
    label: '生产采购（30天）'
  },
  {
    value: 90 * 24 * 60 * 60 * 1000,
    label: '季度采购（90天）'
  }
]


export default class LeadsCardContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardShowState: true,
      keyword: window.pageConfig.keywords,
      mobilePhone: '',
      nlq: '',
      //volumn: '',
      authDeadline:  Date.now() + 604800000,
      isLogin: false,
      isNeedVerification: false,
      formSending: false,
      smsCode: '',
      time: 14 * 24 * 60 * 60 * 1000
    };

    this.handleChangeCascaderSelect = this.handleChangeCascaderSelect.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getSmsCode = this.getSmsCode.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleSmsCodeChange = this.handleSmsCodeChange.bind(this);
  }

  async componentDidMount() {
    if(this.getItemWithExpiration("closeLeadsCard")) {
      this.setState({
        cardShowState: false,
      });
    }

    try {
      if(!this.getItemWithExpiration("closeLeadsCard") && this.state.cardShowState) {
        goldlog.record(
          "/ifission.ifission.leadsCardExp",
          "EXP",
          "position=card"
        );
      } else {
        goldlog.record(
          "/ifission.ifission.leadsCardExp",
          "EXP",
          "position=icon"
        );
      }
    } catch (error) {
      console.log(error);
    }

    const isLogin = await getLogin();

    if(isLogin) {
      const mobilePhone = await queryMobilePhone();
      this.setState({
        mobilePhone
      })
    }

    this.setState({
      isLogin
    });
  }

  setItemWithExpiration(key, value) {
    const now = new Date();
    const item = {
        value: value,
        expiry: now.getTime() + 24 * 60 * 60 * 1000 // 当前时间加一天的毫秒数
    };
    localStorage.setItem(key, JSON.stringify(item));
  }

  getItemWithExpiration(key) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) {
        return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    
    if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        return null;
    }
    return item.value;
  }

  handleClose() {
    this.setItemWithExpiration('closeLeadsCard', true);
    this.setState({
      cardShowState: false,
    });
    goldlog.record(
      "/ifission.ifission.leadsCardClk",
      "CLK",
      `position=close`
    );
  }

  handleOpen() {
    this.setState({
      cardShowState: true,
    });

    goldlog.record(
      "/ifission.ifission.leadsCardClk",
      "CLK",
      `position=open`
    );
  }

  handleSmsCodeChange(val) {
    this.setState({
      smsCode: val,
    });
  }

  handleChangeCascaderSelect(time) {
    const currentTimestamp = Date.now();
    let authDeadline = currentTimestamp + time;

    this.setState({
      time,
      authDeadline
    });
  }

  async handleSubmit() {
    let {
      keyword,
      mobilePhone,
      nlq,
      //volumn,
      authDeadline,
      isNeedVerification,
      smsCode
    } = this.state;


    if(!this.checkKeyword(keyword)) {
      return;
    }

    if (!mobilePhone.includes("****")) {
      if(!this.phoneNumberCheck(mobilePhone)) {
        return;
      }
    } else {
      mobilePhone = "";
    }

    // 存在风险，验证码必填
    if(isNeedVerification) {
      if(!this.checkSmsCodeAndNlq(smsCode, nlq)) {
        return;
      }
    }

    let params = {
      keyword,
      mobilePhone,
      nlq,
      //volumn,
      authDeadline
    };

    if(smsCode && smsCode.length > 0) {
      params.smsCode = smsCode;
    }

    //console.log(params);

    const res = await cplRepo(params);

    if (Number(res.code) === 4010) {
      this.setState({
        isNeedVerification: true,
      });
      Feedback.toast.show({
        type: "error",
        content: '请填写验证码',
         size: 'large'
      });
    } else if (res.code === "200") {
      Feedback.toast.show({
        type: "success",
        content: '您的采购需求已提交，请保持电话畅通，商家会尽快联系您',
         size: 'large'
      });

      this.setState({
        isNeedVerification: false,
        keyword: '',
        nlq: '',
        smsCode: '',
        time: 14 * 24 * 60 * 60 * 1000
      });
    } else {
      Feedback.toast.show({
        type: "error",
        content: res.msg,
         size: 'large'
      });
    }

    goldlog.record(
      "/ifission.ifission.leadsCardClk",
      "CLK",
      `position=submit`
    );
  }

  checkKeyword(keyword) {
    if (!keyword || keyword.trim() === "") {
      Feedback.toast.show({
        type: "error",
        content: "采购商品不能为空",
         size: 'large'
      });
      return false;
    }
    return true;
  }

  checkSmsCodeAndNlq(smsCode, nlq) {
    if (!smsCode) {
      Feedback.toast.show({
        type: "error",
        content: '请填写验证码',
        size: 'large'
      });
      return false;
    }
    // 存在风险，留言信息必填
    if (!nlq) {
      Feedback.toast.show({
        type: "error",
        content: '请填写留言信息',
        size: 'large'
      });
      return false;
    }
    return true;
  }

  phoneNumberCheck(phoneNumber) {
    const phoneNumReg = /^1(3|4|5|6|7|8|9)\d{9}$/;
    if ((''+phoneNumber).trim() === "") {
      Feedback.toast.show({
        type: "error",
        content: "电话号码不能为空",
         size: 'large'
      });
      return false;
    } else if (!phoneNumReg.test(phoneNumber)) {
      Feedback.toast.show({
        type: "error",
        content: "请填写正确的电话号码",
         size: 'large'
      });
      return false;
    }
    return true;
  }

  getSmsCode() {
    let {
      mobilePhone,
    } = this.state;

    if (!mobilePhone.includes("****")) { 
      if (this.phoneNumberCheck(mobilePhone)) {
        this.sendSmsCode(mobilePhone);
      }
    } else {
      this.sendSmsCode(null);
    }
  };
  
  async sendSmsCode(mobilePhone) {

    const code = await sendSmsCode(mobilePhone ? mobilePhone + "" : null);
    if (Number(code) === 200) {
      Feedback.toast.show({
        type: "prompt",
        content: "验证码已发送",
         size: 'large'
      });
    } else if (Number(code) === 4012) {
      Feedback.toast.show({
        type: "prompt",
        content: "短信验证码已发送,请稍后再试",
         size: 'large'
      });
    }
  }

  renderCard() {
    const {
      keyword,
      mobilePhone,
      nlq,
      //volumn,
      isNeedVerification,
      smsCode,
      time
    } = this.state;
    //console.log(isNeedVerification)

    return (
      <div className="leads-card-content">
        <div className="leads-card-title">
          <div className="leads-card-title-left">
            <img 
              src="https://img.alicdn.com/imgextra/i4/O1CN01EovnQz27768t4lmBx_!!6000000007749-2-tps-64-64.png"
              className="leads-card-title-icon"
            />
            <div className="leads-card-title-text">采购助手</div>
          </div>
          
          <div className="leads-card-content-close" onClick={this.handleClose}></div>
        </div>

        <div className="leads-card-content-tip">
          Hi，我是1688采购小助手，为您匹配优质货源，您可以点击提交一键获取专属服务~
        </div>
        
        <div className="leads-card-content-form">
          <div className="leads-card-content-form-item">
            <div className="leads-card-content-form-item-title-wrap">
              <span className="leads-card-content-form-item-required">*</span>
              <span className="leads-card-content-form-item-text">采购商品</span>
            </div>

            <Input
              maxLength={13}
              onChange={(value) => this.setState({ keyword: value })}
              className="leads-card-content-form-item-input"
              value={keyword}
            />
          </div>
          <div className="leads-card-content-form-item">
            <div className="leads-card-content-form-item-title-wrap">
              <span className="leads-card-content-form-item-required">*</span>
              <span className="leads-card-content-form-item-text">联系电话</span>
            </div>
            <Input
              value={mobilePhone}
              maxLength={13}
              onChange={(value) => this.setState({ mobilePhone: value })}
              className="leads-card-content-form-item-input"
            />
          </div>
          {
            isNeedVerification && 
            <div className="leads-card-content-form-item">
              <div className="leads-card-content-form-item-title-wrap">
                <span className="leads-card-content-form-item-required">*</span>
                <span className="leads-card-content-form-item-text">验证码</span>
              </div>
              <Input
                className="leads-card-content-form-item-input-smscode"
                type="phone"
                onChange={this.handleSmsCodeChange}
                value={smsCode}
                //placeholder="验证码"
                style={{
                  display: 'inlineBlock'
                }}
              />
              <CountdownButton buttonClick={this.getSmsCode}></CountdownButton>
            </div>
          }
          {
            /*<div className="leads-card-content-form-item">
            <div className="leads-card-content-form-item-title-wrap">
              <span className="leads-card-content-form-item-text">采购数量</span>
            </div>
            <Input
              value={volumn}
              maxLength={13}
              onChange={(value) => this.setState({ volumn: value })}
              className="leads-card-content-form-item-input"
            />
          </div>
          */}
          <div className="leads-card-content-form-item">
            <div className="leads-card-content-form-item-title-wrap">
              <span className="leads-card-content-form-item-text">详细要求</span>
            </div>
            <textArea
              onChange={(e) => this.setState({ nlq: e.target.value })}
              className="leads-card-content-form-item-textArea"
              placeholder="如：采购数量、用途、物流要求、开票要求等"
              value={nlq}
            />
          </div>
          <div className="leads-card-content-form-item">
            <div className="leads-card-content-form-item-title-wrap">
              <span className="leads-card-content-form-item-text">采购周期</span>
            </div>
            <CascaderSelect 
              dataSource={staticData}
              defaultValue={time}
              onChange={this.handleChangeCascaderSelect} 
              className="leads-card-content-form-item-cascaderSelect"
            />
          </div>
        </div>

        <div className="leads-card-content-protocol">
          点击提交视为同意
          <a
            href="https://terms.alicdn.com/legal-agreement/terms/c_end_product_protocol/20231031181421701/20231031181421701.html?spm=a261y.25179003.0.0.56883aa7cMyD2U"
            target="_blank"
          >
            《用户协议》
          </a>
        </div>

        <div 
          className="leads-card-content-btn"
          onClick={this.handleSubmit}
        >
          提交采购需求
        </div>
      </div>
    );
  }

  render() {
    
    return (
      <div className="leads-card-container">
        {
          this.state.cardShowState ? 
            this.renderCard()
          : 
            <div className="leads-card-icon" onClick={this.handleOpen}>

            </div>
        }
      </div>
    );
  }
}